var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_35_1",
    "data-name": "Componente 35 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.092,
    height: 9.938,
    viewBox: "0 0 17.092 9.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e02a58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#be0031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2633",
    "data-name": "Rect\\xE1ngulo 2633",
    width: 17.092,
    height: 9.938,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4996",
    "data-name": "Grupo 4996",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4995",
    "data-name": "Grupo 4995",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9110",
    "data-name": "Trazado 9110",
    d: "M8.545,3.135a1.7,1.7,0,1,1-1.7,1.7.294.294,0,0,1,.267-.3.3.3,0,0,1,.3.3A1.134,1.134,0,1,0,8.545,3.7a.3.3,0,0,1-.3-.3.272.272,0,0,1,.3-.267m0,4.269A2.568,2.568,0,1,0,5.978,4.836,2.591,2.591,0,0,0,8.545,7.4m0-5.7A3.135,3.135,0,1,1,5.41,4.836,3.132,3.132,0,0,1,8.545,1.7m0,7.67c3.869,0,7.171-3.668,7.871-4.535-.7-.834-4-4.269-7.871-4.269S1.375,4,.675,4.836c.7.867,4,4.535,7.87,4.535m6-7.036a16.241,16.241,0,0,1,2.468,2.3.261.261,0,0,1,0,.367c-.133.2-3.835,4.936-8.471,4.936S.208,5.2.075,5a.263.263,0,0,1,0-.367,16.293,16.293,0,0,1,2.468-2.3A10.316,10.316,0,0,1,8.545,0a10.316,10.316,0,0,1,6,2.334",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.7ba3d2f5139e1d94e4db295100595e11.svg";
export { ForwardRef as ReactComponent };